
import { Profile } from '@/contexts/AuthContext';

export interface ProfileCompletionResult {
  isComplete: boolean;
  missingFields: string[];
  missingFieldsTranslated: {
    en: string[];
    ar: string[];
  };
}

export const checkProfileCompletion = (profile: Profile | null, action: 'listing' | 'contact'): ProfileCompletionResult => {
  if (!profile) {
    return {
      isComplete: false,
      missingFields: ['profile'],
      missingFieldsTranslated: {
        en: ['Profile information'],
        ar: ['معلومات الملف الشخصي']
      }
    };
  }

  const missingFields: string[] = [];
  const missingFieldsEn: string[] = [];
  const missingFieldsAr: string[] = [];

  // Required fields for both listing and contact
  const requiredFields = [
    { field: 'phone', en: 'Phone Number', ar: 'رقم الهاتف' },
    { field: 'national_id', en: 'National ID', ar: 'رقم الهوية الوطنية' },
    { field: 'address_country', en: 'Country', ar: 'البلد' },
    { field: 'address_city', en: 'City', ar: 'المدينة' },
    { field: 'address_area', en: 'Area', ar: 'المنطقة' },
    { field: 'address_street', en: 'Street', ar: 'الشارع' },
  ];

  // Check each required field
  requiredFields.forEach(({ field, en, ar }) => {
    if (!profile[field as keyof Profile] || profile[field as keyof Profile] === '') {
      missingFields.push(field);
      missingFieldsEn.push(en);
      missingFieldsAr.push(ar);
    }
  });

  // Gender is required for students when contacting
  if (action === 'contact' && profile.role === 'student' && (!profile.gender || profile.gender === '')) {
    missingFields.push('gender');
    missingFieldsEn.push('Gender');
    missingFieldsAr.push('الجنس');
  }

  return {
    isComplete: missingFields.length === 0,
    missingFields,
    missingFieldsTranslated: {
      en: missingFieldsEn,
      ar: missingFieldsAr
    }
  };
};
